import React from 'react';
import { BrainIcon, ClipboardListIcon, FolderTreeIcon, HelpCircleIcon, RotateCcwIcon, TimerIcon, LayoutDashboardIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const pains = [{
  Icon: HelpCircleIcon,
  text: 'You have an aligner case in front of you and don’t know where to start organizing it'
}, {
  Icon: TimerIcon,
  text: 'You spend too much time going back through courses, notes, PDFs, and different resources'
}, {
  Icon: ClipboardListIcon,
  text: 'You have several things to review before an installation appointment'
}, {
  Icon: LayoutDashboardIcon,
  text: 'You don’t have one practical workflow for tracking the different stages of treatment'
}, {
  Icon: RotateCcwIcon,
  text: 'When a case requires reassessment, you have to reconstruct the entire case history'
}, {
  Icon: BrainIcon,
  text: 'Your workflow depends too much on memory instead of a repeatable organization system'
}, {
  Icon: FolderTreeIcon,
  text: 'You wish you had one place where the entire case could be visually organized'
}];
export function Recognize() {
  return <section className="w-full bg-white py-14 md:py-20" aria-labelledby="recognize-title" data-id="element-242" data-mp="1df2ygk7mchuv">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-243" data-mp="1s5a582o9kcfq">
        <h2 id="recognize-title" className="text-center font-display text-[26px] font-black uppercase leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-244" data-mp="1n6p50390hsra">
          Do You Recognize Yourself in Any of These?
        </h2>

        <ul className="mt-8 grid gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-245" data-mp="uke935wcog0t">
          {pains.map(({
          Icon,
          text
        }) => <li key={text} className="flex items-start gap-4 rounded-2xl border border-navy-900/10 bg-mist px-4 py-4 sm:px-5" data-id="element-246" data-mp="14gha28fgu8m6">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white ring-1 ring-navy-900/10" data-id="element-247" data-mp="2kswcbkwp9z7c">
                <Icon className="h-5 w-5 text-brand-600" aria-hidden="true" data-id="element-248" data-mp="2myuhmnhkj1lb" />
              </span>
              <span className="text-[14px] font-medium leading-snug text-navy-900 sm:text-[15px]" data-id="element-249" data-mp="2rxxhltioyhmf">
                {text}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-250" data-mp="2wv5yzrw0mhmm">
          <p className="font-display text-xl font-black uppercase leading-tight text-navy-950 sm:text-3xl" data-id="element-251" data-mp="31usek7zbg9yl">
            You Don’t Need More Information…
          </p>
          <p className="mt-2 font-display text-lg font-black uppercase leading-tight text-brand-600 sm:text-2xl" data-id="element-252" data-mp="296wj16lhgo3e">
            You Need A Command Center For The Information You Already Have.
          </p>
          <div className="mt-7" data-id="element-253" data-mp="2ixhdchu4j6gi">
            <CTAButton label="Yes, I want the Command Center" data-id="element-254" data-mp="2iysesb03k24g" />
          </div>
        </div>
      </div>
    </section>;
}